export enum CustomerCompensationType {
    FIXED = 'FIXED',
    PERCENTAGE = 'PERCENTAGE'
}

export const customerTypeDisplay = {
    [CustomerCompensationType.FIXED]: 'Fixed',
    [CustomerCompensationType.PERCENTAGE]: 'Percentage'
};
